import { render, staticRenderFns } from "./detailView.vue?vue&type=template&id=71578bba&scoped=true&"
import script from "./detailView.vue?vue&type=script&lang=ts&"
export * from "./detailView.vue?vue&type=script&lang=ts&"
import style0 from "./detailView.vue?vue&type=style&index=0&id=71578bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71578bba",
  null
  
)

export default component.exports